import type { ProductFeatureFlags } from '../feature-flags';

import { useLinkProps, type LinkProps } from './hooks/use-link-props';
import { useAddFlag, useNavigationActions, useRemoveFlag } from './provider';
import { useNavigationState } from './store';
import { useAppConfigStoreState } from './store/main';
import type { OpenPreviewPanelProps, FlagProps, AppName } from './types';

// Combine the RSS with the Context
export const useNavigation = (): {
	getLinkProps: (
		props: LinkProps & {
			openPreviewPanelProps?: OpenPreviewPanelProps;
		},
	) => LinkProps;
	contextSpaPaths: string[] | undefined;
	contextEntryPoint: string | null | undefined;
	push: (url: string) => void;
	replace: (url: string) => void;
} => {
	const state = useNavigationState();
	const actions = useNavigationActions();
	const getLinkProps = useLinkProps();
	return { ...actions, ...state, getLinkProps };
};

export const useAppConfig = (): {
	addFlag: (props: FlagProps) => void;
	removeFlag: (id: number | string) => void;
	getLinkProps: (
		props: LinkProps & {
			openPreviewPanelProps?: OpenPreviewPanelProps;
		},
	) => LinkProps;
	contextSpaPaths: string[] | undefined;
	contextEntryPoint: string | null | undefined;
	push: (url: string) => void;
	replace: (url: string) => void;
	docTitle?: {
		start?: string;
		end?: string;
		delimiter?: string;
	};
	invitePeopleExperimentalFeatures?: {};
	stargateRoot: string;
	cloudId?: string | null;
	orgId?: string;
	principalUserId?: string;
	env?: 'prod' | 'stg';
	appName?: AppName;
	productName?: string | null;
	subProduct?: string | null;
	locale?: string;
	isJiraAvailable?: boolean;
	productFeatureFlags?: Partial<ProductFeatureFlags>;
	openLinksInNewTab?: boolean;
	openPreviewPanel?: (props: OpenPreviewPanelProps) => void;
	openGiveKudosInNewTab?: boolean;
} => {
	const storeState = useAppConfigStoreState();
	const navigation = useNavigation();
	const addFlag = useAddFlag();
	const removeFlag = useRemoveFlag();

	return {
		...storeState,
		...navigation,
		addFlag,
		removeFlag,
	};
};
